import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultTypeContent: PageTypeContentModule = {
  pageTypeSlug: "default-type",
  suggestedTitles: ["Welcome", "Home", "Main Page"],
  suggestedSlugs: ["welcome", "home", "main"],
  description: "Generic default page template",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Welcome", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Welcome to our website. This is a placeholder page that you can customize with your own content.",
        },
      },
      {
        type: "paragraph",
        data: {
          text: "Add your text here to create engaging content for your visitors.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
